import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import axios from 'axios'
import Multiselect from 'vue-multiselect'

// register globally
Vue.component('multiselect', Multiselect)
//font awesome
require('./plugins/fontawesome');
window.axios=axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
